import "../css/JobForm.css";


export default function DronePilotForm() {
  return (
    <div className="job-form-container">
      <h1>Apply – Drone Pilot</h1>
      <p>Aerial spraying & precision farming</p>

      <div className="job-form-grid">
        <input placeholder="Full Name" />
        <input placeholder="Phone Number" />
        <input placeholder="DGCA License Number" />
        <input placeholder="Drone Model Used" />
        <input placeholder="Total Flight Hours" />
        <textarea placeholder="Past Drone Operations Experience" />
      </div>

      <button>Submit Application</button>
    </div>
  );
}
